/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Add_New_Term_TitleInputs */



/**
* | output |
* | --- |
* | "Add new term" |
*
* @param {Knp_Terms_Add_New_Term_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_add_new_term_title = /** @type {((inputs?: Knp_Terms_Add_New_Term_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Add_New_Term_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un nouveau terme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Begriff hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi nuovo termine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить новый термин")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir nuevo término")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新术语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい用語を追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया शब्द जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo termo")
	return /** @type {LocalizedString} */ ("Add new term")
});